<template>
  <v-row
    align="center"
    justify="center"
    class="ma-0"
  >
    <v-col
      cols="12"
      sm="8"
      md="4"
      lg="4"
      xl="3"
    >
      <p class="body-1">
        2FA
      </p>
      <v-card outlined>
        <form @submit.prevent="save">
          <v-container fluid>
            <template v-if="!recovery">
              <v-card-text>
                Please confirm access to your account by entering the authentication code provided by your authenticator application.
              </v-card-text>
              <v-card-text>
                <v-text-field
                  v-model="form.code"
                  label="Code"
                  outlined
                  :class="{ 'is-invalid': form.errors.code }"
                  class="form-control"
                  name="code"
                  :error="form.errors.code === true"
                  :error-messages="form.errors.code"
                />
              </v-card-text>
            </template>
            <template v-else>
              <v-card-text>
                Please confirm access to your account by entering one of your emergency recovery codes.
              </v-card-text>
              <v-card-text>
                <v-text-field
                  v-model="form.recovery_code"
                  label="Recovery Code"
                  outlined
                  :class="{ 'is-invalid': form.errors.recovery_code }"
                  class="form-control"
                  name="recovery_code"
                  :error="form.errors.recovery_code"
                  :error-messages="form.errors.recovery_code"
                />
              </v-card-text>
            </template>
            <v-card-actions>
              <v-btn
                depressed
                color="primary"
                @click="recovery = !recovery"
              >
                {{ !recovery ? "Use a recovery code" : "Use an authentication code" }}
              </v-btn>
              <v-spacer />
              <v-btn
                depressed
                :loading="loading"
                color="primary"
                type="submit"
              >
                Login
              </v-btn>
            </v-card-actions>
          </v-container>
        </form>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import Layout from '@/Layouts/Basic'

export default {
   metaInfo: { title: '2FA' },

   layout: (h, page) => h(Layout, [page]),
   data () {
      return {
         recovery: false,
         loading: false,
         form: {
            code: null,
            recovery_code: null
         },
      }
   },

   methods: {
      save () {
         this.loading = true
         if (this.recovery) {
            this.$inertia.post('/two-factor-challenge', { recovery_code: this.form.recovery_code }).then(() => this.loading = false)
         } else {
            this.$inertia.post('/two-factor-challenge', { code: this.form.code }).then(() => this.loading = false)
         }
      },
   },
}
</script>
